// Vendors
import React from 'react';

// Components
import FormattedMessage from '@molecules/FormattedMessage';

interface ErrorBoundaryProps {
  children?: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state = { hasError: false };

  static getDerivedStateFromError(error: Error) {
    console.log(error);
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <h1>
          <FormattedMessage id="APP.ERROR_MESSAGE" />
        </h1>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
